import { render, staticRenderFns } from "./Mecanica.vue?vue&type=template&id=9348c762"
import script from "./Mecanica.vue?vue&type=script&lang=js"
export * from "./Mecanica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports